module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"confirmCloseDialog":{"title":"Leave and discard?","body":"All of the changes you made will be lost.","confirmButtonLabel":"Leave and discard","cancelButtonLabel":"Go back"}}}')
  delete Component.options._Ctor
}
